import React from 'react'
import { generateProposalReport, getProposalReport } from '../services/api'
import GenerateReport from '../components/GenerateReport'

const ProposalReport = () => {

  const config = [
    {
      key: 'standardsPublish',
      apiKey: 'standards_publish',
      type: 'publish',
      title: 'Standarder för fastställelse',
      moduleId: 'standards-publish'
    },
    {
      key: 'standardsAnnulment',
      apiKey: 'standards_annulment',
      type: 'annulment',
      title: 'Standarder för upphävande',
      moduleId: 'standards-annulment'
    },
    {
      key: 'trPublish',
      apiKey: 'TR_publish',
      type: 'publish',
      title: 'SEK Teknisk Rapport för publicering',
      moduleId: 'TR-publish'
    },
    {
      key: 'tsPublish',
      apiKey: 'TS_publish',
      type: 'publish',
      title: 'SEK Teknisk Specifikation för publicering',
      moduleId: 'TS-publish'
    },
  ]; 

  return (
    <GenerateReport
      type='proposalReport'
      title='förslagslista'
      name='Lista förslag för fastställelse och upphävande av svensk standard'
      initialItems={{
        standardsPublish: [],
        standardsAnnulment: [],
        trPublish: [],
        tsPublish: [],
      }}
      dateStorageKeys={{
        dop: 'dop_date-PR',
        dowFrom: 'dow_date_from-PR',
        dowTo: 'dow_date_to-PR'
      }}
      config={config}
      fetchReport={({ dopDate, dowDateFrom, dowDateTo }) =>
        getProposalReport(dopDate, dowDateFrom, dowDateTo)
      }
      generateReport={(dates, report) => 
        generateProposalReport(dates, report)
      }
    />
  )
}

export default ProposalReport